module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAMFJREFUOE9jZIACPT03bhbO78owPoxmZGb9+vMv45crJ/e+RJcD8RlhgsZWDncYGRgwDGD4z3CUgeHfvP+MTFW/v7DpX7q06yuyQXADTKwc/mOzAWYAAyPT3P8MDHfRDSHJAJAF6IYQZcC/f3+zmJgYTWAu/MfA/PTc8f07UcIApxdAtv5nKGBk+PcZbsC//2fOnTx8iWgD0MPm////dWePH2weNWA0DDDSgbGVfS/jfwYBrBkKI48zbj9z7MAakDAA7IuWEQTP7qUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu/ic_dsbaitap.png
// module id = 1267
// module chunks = 0